// extracted by mini-css-extract-plugin
module.exports = {"black":"colors-module--black--3rjd2","white":"colors-module--white--2Q2nN","blue":"colors-module--blue--1cqOh"};